const GenerateSvg = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
      <path
        d="M3.0025 1.69152V14.3072C3.0025 14.6895 3.30001 15 3.66628 15H12.3688C12.7351 15 13 14.704 13 14.3218V5.79534C13 5.62833 12.9467 5.33762 12.8405 5.21106L9.37031 1.23747C9.24405 1.08611 9.06154 1 8.86903 1H3.66378C3.29752 1 3 1.31053 3 1.69282L3.0025 1.69152Z"
        stroke="#333333"
        strokeMiterlimit="10"
      />
      <path d="M9.16211 1V4.58156C9.16211 4.92256 9.50134 5.18994 9.84515 5.18994H13.1621" stroke="#333333" strokeMiterlimit="10" />
      <path d="M6.16211 9H10.1621" stroke="#333333" strokeLinecap="round" />
      <path d="M8.16211 7V9V11" stroke="#333333" strokeLinecap="round" />
    </svg>
  );
};

export default GenerateSvg;
